<template>
  <div class="flex flex-col flex-1">
    <p class="p-4 text-gray-60 text-sm">
      Välj ett tåg i listan nedan och klicka på "Sök" för att hämta
    </p>
    <div class="flex flex-col flex-1 p-4 w-full overflow-y-auto">
      <table :class="$style.table">
        <thead>
          <tr>
            <th>Core</th>
            <th>Variant</th>
            <th>UIC</th>
            <th>Sökande</th>
            <th>Operatör</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(o, $i) in operators"
            :key="$i"
            @click="selectedRow = $i"
            :class="[selectedRow === $i && $style.selectedRow]"
          >
            <td>{{ o.tekniskttagnummer }}</td>
            <td>{{ o.variant }}</td>
            <td>{{ o.company }}</td>
            <td>{{ o.sokande }}</td>
            <td>{{ o.operator }}</td>
            <td style="min-width: 30px;">
              <i
                class="material-icons type-scale-1 text-primary"
                v-if="$i === selectedRow"
                >check_circle</i
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex justify-end items-center">
      <AppButton @click="closeModal" kind="secondary">Avbryt</AppButton>
      <AppButton :disabled="selectedRow === null" @click="onConfirm"
        >Sök</AppButton
      >
    </div>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'TimetableSelectOperatorModal',

  data() {
    return {
      selectedRow: null
    }
  },

  computed: {
    operators: get('trainSchedule/operators'),
    plans: get('migratedPlan/all'),
    activePlanId: get('migratedPlan/active'),
    activeOperator: get('trainSchedule/activeOperator'),
    activePlan() {
      return this.plans[this.activePlanId]
    }
  },

  methods: {
    onConfirm() {
      this.$store.set(
        'trainSchedule/activeOperator',
        this.operators[this.selectedRow]
      )

      this.$store.set('trainSchedule/display', {
        operator: this.operators[this.selectedRow].operator,
        sokande: this.operators[this.selectedRow].sokande
      })
      this.$store.dispatch('trainSchedule/fetchAll', {
        planId: this.activePlan.sysid,
        tekniskttagnummer: this.technicalNumber
      })
      this.closeModal()
    },

    closeModal() {
      this.$store.set('trainSchedule/showSelectOperatorModal', false)
    }
  }
}
</script>

<style lang="postcss" module>
.table {
  @apply w-full mt-2;
}

.table th {
  @apply font-bold text-left text-sm bg-gray-10 p-2 !important;
}

.table td {
  @apply font-light text-left p-2 border-b border-gray-20 !important;
}

.table tbody tr:hover {
  @apply bg-gray-20 cursor-pointer;
}

.selectedRow {
  outline: 2px solid theme('colors.primary.default');
  @apply bg-blue-10;
}
</style>
